import { cx } from '../../lib/cx';

export interface ToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  /** `success` (green) is used by the onboarding WhatsApp-consent row; everything else is `brand`. */
  tone?: 'brand' | 'success';
  /** Required: a switch has no visible text of its own. */
  'aria-label': string;
  className?: string;
}

/** Figma "Toggle" (116:753): 48x28 pill, 22px knob. */
export function Toggle({
  checked,
  onCheckedChange,
  disabled = false,
  tone = 'brand',
  'aria-label': ariaLabel,
  className,
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onCheckedChange(!checked)}
      className={cx(
        'relative inline-flex h-(--mbm-size-toggle-height) w-(--mbm-size-toggle-width) shrink-0 items-center rounded-full',
        'p-[calc((var(--mbm-size-toggle-height)-var(--mbm-size-toggle-knob))/2)]',
        'transition-colors duration-(--mbm-duration-fast) focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring)',
        checked ? (tone === 'success' ? 'bg-feedback-success' : 'bg-brand-primary') : 'bg-border-strong',
        disabled && 'cursor-not-allowed opacity-(--mbm-opacity-disabled)',
        className,
      )}
    >
      <span
        aria-hidden
        className={cx(
          'size-(--mbm-size-toggle-knob) rounded-full bg-surface-card shadow-(--mbm-shadow-sm)',
          'transition-transform duration-(--mbm-duration-fast)',
          checked &&
            'translate-x-[calc(var(--mbm-size-toggle-width)-var(--mbm-size-toggle-knob)-(var(--mbm-size-toggle-height)-var(--mbm-size-toggle-knob)))]',
        )}
      />
    </button>
  );
}
